<template>
  <div class="tabelas-auxiliares">
    <!-- Sub-abas -->
    <div class="sub-tabs">
      <button
        :class="['sub-tab', { active: subAbaAtiva === 'sistemas' }]"
        @click="subAbaAtiva = 'sistemas'"
      >
        <i class="fas fa-hospital"></i>
        Sistemas Inscritos
      </button>
      <button
        :class="['sub-tab', { active: subAbaAtiva === 'captacao' }]"
        @click="subAbaAtiva = 'captacao'"
      >
        <i class="fas fa-bullhorn"></i>
        Formas de Captação
      </button>
    </div>

    <!-- Conteúdo: Sistemas Inscritos -->
    <div v-show="subAbaAtiva === 'sistemas'" class="tab-content">
      <div class="tab-header">
        <h3>Sistemas Inscritos</h3>
        <button class="btn-adicionar" @click="abrirModalSistema()">
          <i class="fas fa-plus"></i> Adicionar
        </button>
      </div>
      <p class="tab-descricao">
        Sistemas de gestão onde os pacientes podem estar cadastrados.
      </p>

      <div v-if="carregandoSistemas" class="loading">
        <i class="fas fa-spinner fa-spin"></i> Carregando...
      </div>

      <draggable
        v-else
        v-model="sistemas"
        item-key="id"
        handle=".drag-handle"
        @end="salvarOrdemSistemas"
        class="lista-items"
      >
        <template #item="{ element }">
          <div class="item-row" :class="{ protegido: element.protegido, inativo: !element.ativo }">
            <span class="drag-handle" :class="{ disabled: element.protegido }">
              <i class="fas fa-grip-vertical"></i>
            </span>
            <span class="item-nome">{{ element.nome }}</span>
            <span class="item-count" :title="element.pacientes_count + ' pacientes'">
              <i class="fas fa-users"></i> {{ element.pacientes_count }}
            </span>
            <label class="toggle-switch" :title="element.ativo ? 'Ativo' : 'Inativo'">
              <input
                type="checkbox"
                :checked="element.ativo"
                @change="toggleAtivoSistema(element)"
              />
              <span class="slider"></span>
            </label>
            <div class="item-actions">
              <button
                class="btn-icon btn-edit"
                title="Editar"
                @click="abrirModalSistema(element)"
              >
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button
                v-if="!element.protegido"
                class="btn-icon btn-delete"
                title="Excluir"
                @click="confirmarExclusaoSistema(element)"
              >
                <i class="fas fa-trash"></i>
              </button>
              <span v-else class="badge-protegido" title="Item protegido">
                <i class="fas fa-lock"></i>
              </span>
            </div>
          </div>
        </template>
      </draggable>
    </div>

    <!-- Conteúdo: Formas de Captação -->
    <div v-show="subAbaAtiva === 'captacao'" class="tab-content">
      <div class="tab-header">
        <h3>Formas de Captação</h3>
        <button class="btn-adicionar" @click="abrirModalCaptacao()">
          <i class="fas fa-plus"></i> Adicionar
        </button>
      </div>
      <p class="tab-descricao">
        Como os pacientes conheceram ou chegaram à clínica.
      </p>

      <div v-if="carregandoCaptacao" class="loading">
        <i class="fas fa-spinner fa-spin"></i> Carregando...
      </div>

      <draggable
        v-else
        v-model="formasCaptacao"
        item-key="id"
        handle=".drag-handle"
        @end="salvarOrdemCaptacao"
        class="lista-items"
      >
        <template #item="{ element }">
          <div class="item-row" :class="{ protegido: element.protegido, inativo: !element.ativo }">
            <span class="drag-handle" :class="{ disabled: element.protegido }">
              <i class="fas fa-grip-vertical"></i>
            </span>
            <span class="item-nome">{{ element.nome }}</span>
            <span class="item-count" :title="element.pacientes_count + ' pacientes'">
              <i class="fas fa-users"></i> {{ element.pacientes_count }}
            </span>
            <label class="toggle-switch" :title="element.ativo ? 'Ativo' : 'Inativo'">
              <input
                type="checkbox"
                :checked="element.ativo"
                @change="toggleAtivoCaptacao(element)"
              />
              <span class="slider"></span>
            </label>
            <div class="item-actions">
              <button
                class="btn-icon btn-edit"
                title="Editar"
                @click="abrirModalCaptacao(element)"
              >
                <i class="fas fa-pencil-alt"></i>
              </button>
              <button
                v-if="!element.protegido"
                class="btn-icon btn-delete"
                title="Excluir"
                @click="confirmarExclusaoCaptacao(element)"
              >
                <i class="fas fa-trash"></i>
              </button>
              <span v-else class="badge-protegido" title="Item protegido">
                <i class="fas fa-lock"></i>
              </span>
            </div>
          </div>
        </template>
      </draggable>
    </div>

    <!-- Modal de Edição/Criação -->
    <Teleport to="body">
      <div v-if="modalAberto" class="modal-overlay" @click.self="fecharModal">
        <div class="modal-mini">
          <div class="modal-mini-header">
            <h3>{{ modalTitulo }}</h3>
            <button class="btn-fechar" @click="fecharModal">&times;</button>
          </div>
          <div class="modal-mini-body">
            <div class="form-group">
              <label>Nome *</label>
              <input
                v-model="modalForm.nome"
                type="text"
                class="form-input"
                :placeholder="modalPlaceholder"
                @keyup.enter="salvarModal"
              />
            </div>
          </div>
          <div class="modal-mini-footer">
            <button class="btn-cancelar" @click="fecharModal">Cancelar</button>
            <button class="btn-salvar" @click="salvarModal" :disabled="!modalForm.nome?.trim()">
              Salvar
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import draggable from 'vuedraggable'

// Estado
const subAbaAtiva = ref('sistemas')
const sistemas = ref([])
const formasCaptacao = ref([])
const carregandoSistemas = ref(false)
const carregandoCaptacao = ref(false)

// Modal
const modalAberto = ref(false)
const modalTipo = ref('sistema') // 'sistema' ou 'captacao'
const modalModo = ref('criar') // 'criar' ou 'editar'
const modalForm = ref({ id: null, nome: '' })

const modalTitulo = ref('')
const modalPlaceholder = ref('')

// Carregar dados
async function carregarSistemas() {
  carregandoSistemas.value = true
  try {
    const response = await axios.get('/api/sistemas-inscritos')
    sistemas.value = response.data
  } catch (error) {
    console.error('Erro ao carregar sistemas:', error)
  } finally {
    carregandoSistemas.value = false
  }
}

async function carregarCaptacao() {
  carregandoCaptacao.value = true
  try {
    const response = await axios.get('/api/formas-de-captacao')
    formasCaptacao.value = response.data
  } catch (error) {
    console.error('Erro ao carregar formas de captação:', error)
  } finally {
    carregandoCaptacao.value = false
  }
}

// Toggle ativo
async function toggleAtivoSistema(item) {
  try {
    await axios.put(`/api/sistemas-inscritos/${item.id}`, { ativo: !item.ativo })
    item.ativo = !item.ativo
  } catch (error) {
    Swal.fire('Erro', 'Não foi possível alterar o status.', 'error')
  }
}

async function toggleAtivoCaptacao(item) {
  try {
    await axios.put(`/api/formas-de-captacao/${item.id}`, { ativo: !item.ativo })
    item.ativo = !item.ativo
  } catch (error) {
    Swal.fire('Erro', 'Não foi possível alterar o status.', 'error')
  }
}

// Reordenar
async function salvarOrdemSistemas() {
  try {
    const ordem = sistemas.value.map(s => s.id)
    await axios.post('/api/sistemas-inscritos/reordenar', { ordem })
  } catch (error) {
    Swal.fire('Erro', 'Não foi possível salvar a ordem.', 'error')
    carregarSistemas()
  }
}

async function salvarOrdemCaptacao() {
  try {
    const ordem = formasCaptacao.value.map(f => f.id)
    await axios.post('/api/formas-de-captacao/reordenar', { ordem })
  } catch (error) {
    Swal.fire('Erro', 'Não foi possível salvar a ordem.', 'error')
    carregarCaptacao()
  }
}

// Modal
function abrirModalSistema(item = null) {
  modalTipo.value = 'sistema'
  modalModo.value = item ? 'editar' : 'criar'
  modalForm.value = item ? { id: item.id, nome: item.nome } : { id: null, nome: '' }
  modalTitulo.value = item ? 'Editar Sistema' : 'Novo Sistema'
  modalPlaceholder.value = 'Ex: WEBDIET'
  modalAberto.value = true
}

function abrirModalCaptacao(item = null) {
  modalTipo.value = 'captacao'
  modalModo.value = item ? 'editar' : 'criar'
  modalForm.value = item ? { id: item.id, nome: item.nome } : { id: null, nome: '' }
  modalTitulo.value = item ? 'Editar Forma de Captação' : 'Nova Forma de Captação'
  modalPlaceholder.value = 'Ex: TikTok'
  modalAberto.value = true
}

function fecharModal() {
  modalAberto.value = false
  modalForm.value = { id: null, nome: '' }
}

async function salvarModal() {
  if (!modalForm.value.nome?.trim()) return

  try {
    if (modalTipo.value === 'sistema') {
      if (modalModo.value === 'criar') {
        await axios.post('/api/sistemas-inscritos', { nome: modalForm.value.nome })
        Swal.fire('Sucesso', 'Sistema criado com sucesso!', 'success')
      } else {
        await axios.put(`/api/sistemas-inscritos/${modalForm.value.id}`, { nome: modalForm.value.nome })
        Swal.fire('Sucesso', 'Sistema atualizado com sucesso!', 'success')
      }
      carregarSistemas()
    } else {
      if (modalModo.value === 'criar') {
        await axios.post('/api/formas-de-captacao', { nome: modalForm.value.nome })
        Swal.fire('Sucesso', 'Forma de captação criada com sucesso!', 'success')
      } else {
        await axios.put(`/api/formas-de-captacao/${modalForm.value.id}`, { nome: modalForm.value.nome })
        Swal.fire('Sucesso', 'Forma de captação atualizada com sucesso!', 'success')
      }
      carregarCaptacao()
    }
    fecharModal()
  } catch (error) {
    const msg = error.response?.data?.message || error.response?.data?.error || 'Erro ao salvar.'
    Swal.fire('Erro', msg, 'error')
  }
}

// Excluir
async function confirmarExclusaoSistema(item) {
  const result = await Swal.fire({
    title: 'Excluir Sistema',
    html: item.pacientes_count > 0
      ? `<p><strong>${item.nome}</strong> está sendo usado por <strong>${item.pacientes_count} pacientes</strong>.</p>
         <p>Os pacientes existentes <strong>não serão afetados</strong>, mas este valor não estará mais disponível para novos cadastros.</p>
         <p>Deseja continuar?</p>`
      : `<p>Deseja excluir <strong>${item.nome}</strong>?</p>`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sim, excluir',
    cancelButtonText: 'Cancelar',
  })

  if (result.isConfirmed) {
    try {
      await axios.delete(`/api/sistemas-inscritos/${item.id}`)
      Swal.fire('Excluído', 'Sistema excluído com sucesso.', 'success')
      carregarSistemas()
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao excluir.'
      Swal.fire('Erro', msg, 'error')
    }
  }
}

async function confirmarExclusaoCaptacao(item) {
  const result = await Swal.fire({
    title: 'Excluir Forma de Captação',
    html: item.pacientes_count > 0
      ? `<p><strong>${item.nome}</strong> está sendo usado por <strong>${item.pacientes_count} pacientes</strong>.</p>
         <p>Os pacientes existentes <strong>não serão afetados</strong>, mas este valor não estará mais disponível para novos cadastros.</p>
         <p>Deseja continuar?</p>`
      : `<p>Deseja excluir <strong>${item.nome}</strong>?</p>`,
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#d33',
    cancelButtonColor: '#3085d6',
    confirmButtonText: 'Sim, excluir',
    cancelButtonText: 'Cancelar',
  })

  if (result.isConfirmed) {
    try {
      await axios.delete(`/api/formas-de-captacao/${item.id}`)
      Swal.fire('Excluído', 'Forma de captação excluída com sucesso.', 'success')
      carregarCaptacao()
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao excluir.'
      Swal.fire('Erro', msg, 'error')
    }
  }
}

// Inicialização
onMounted(() => {
  carregarSistemas()
  carregarCaptacao()
})
</script>

<style scoped>
.tabelas-auxiliares {
  padding: 0;
}

/* Sub-abas */
.sub-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  border-bottom: 2px solid var(--border-color, #e5e7eb);
  padding-bottom: 0;
}

.sub-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  border: none;
  background: transparent;
  color: var(--text-secondary, #6b7280);
  font-size: 14px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  margin-bottom: -2px;
  transition: all 0.2s;
}

.sub-tab:hover {
  color: var(--primary-color, #10b981);
}

.sub-tab.active {
  color: var(--primary-color, #10b981);
  border-bottom-color: var(--primary-color, #10b981);
  font-weight: 600;
}

/* Tab content */
.tab-content {
  animation: fadeIn 0.2s ease;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}

.tab-header h3 {
  margin: 0;
  font-size: 16px;
  color: var(--text-primary, #1f2937);
}

.tab-descricao {
  color: var(--text-secondary, #6b7280);
  font-size: 13px;
  margin: 0 0 16px 0;
}

.btn-adicionar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: var(--primary-color, #10b981);
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-adicionar:hover {
  background: var(--primary-hover, #059669);
}

/* Loading */
.loading {
  text-align: center;
  padding: 40px;
  color: var(--text-secondary, #6b7280);
}

/* Lista de items */
.lista-items {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: var(--bg-secondary, #f9fafb);
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 8px;
  transition: all 0.2s;
}

.item-row:hover {
  border-color: var(--primary-color, #10b981);
}

.item-row.inativo {
  opacity: 0.6;
}

.item-row.protegido {
  background: var(--bg-tertiary, #f3f4f6);
}

.drag-handle {
  cursor: grab;
  color: var(--text-tertiary, #9ca3af);
  padding: 4px;
}

.drag-handle:active {
  cursor: grabbing;
}

.drag-handle.disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

.item-nome {
  flex: 1;
  font-weight: 500;
  color: var(--text-primary, #1f2937);
}

.item-count {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: var(--text-secondary, #6b7280);
  background: var(--bg-tertiary, #e5e7eb);
  padding: 4px 8px;
  border-radius: 12px;
}

/* Toggle switch */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  cursor: pointer;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 22px;
  transition: 0.3s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  border-radius: 50%;
  transition: 0.3s;
}

.toggle-switch input:checked + .slider {
  background-color: var(--primary-color, #10b981);
}

.toggle-switch input:checked + .slider:before {
  transform: translateX(18px);
}

/* Actions */
.item-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.btn-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-edit {
  background: var(--bg-tertiary, #e5e7eb);
  color: var(--text-secondary, #6b7280);
}

.btn-edit:hover {
  background: var(--primary-color, #10b981);
  color: white;
}

.btn-delete {
  background: var(--bg-tertiary, #e5e7eb);
  color: var(--text-secondary, #6b7280);
}

.btn-delete:hover {
  background: #ef4444;
  color: white;
}

.badge-protegido {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-tertiary, #9ca3af);
}

/* Modal mini */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}

.modal-mini {
  background: var(--bg-primary, white);
  border-radius: 12px;
  width: 100%;
  max-width: 400px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}

.modal-mini-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-color, #e5e7eb);
}

.modal-mini-header h3 {
  margin: 0;
  font-size: 16px;
}

.btn-fechar {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: var(--text-secondary, #6b7280);
  line-height: 1;
}

.modal-mini-body {
  padding: 20px;
}

.form-group {
  margin-bottom: 0;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text-primary, #1f2937);
}

.form-input {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid var(--border-color, #e5e7eb);
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.2s;
}

.form-input:focus {
  outline: none;
  border-color: var(--primary-color, #10b981);
}

.modal-mini-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid var(--border-color, #e5e7eb);
}

.btn-cancelar {
  padding: 8px 16px;
  border: 1px solid var(--border-color, #e5e7eb);
  background: white;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-cancelar:hover {
  background: var(--bg-secondary, #f9fafb);
}

.btn-salvar {
  padding: 8px 16px;
  background: var(--primary-color, #10b981);
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s;
}

.btn-salvar:hover:not(:disabled) {
  background: var(--primary-hover, #059669);
}

.btn-salvar:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Dark mode */
:global(.dark-mode) .item-row {
  background: var(--bg-secondary, #1f2937);
  border-color: var(--border-color, #374151);
}

:global(.dark-mode) .sub-tab {
  color: var(--text-secondary, #9ca3af);
}

:global(.dark-mode) .modal-mini {
  background: var(--bg-primary, #111827);
}

:global(.dark-mode) .form-input {
  background: var(--bg-secondary, #1f2937);
  border-color: var(--border-color, #374151);
  color: var(--text-primary, #f9fafb);
}

:global(.dark-mode) .btn-cancelar {
  background: var(--bg-secondary, #1f2937);
  border-color: var(--border-color, #374151);
  color: var(--text-primary, #f9fafb);
}
</style>
